import React from "react";
import styles from "./index.module.css";

interface Props {
  position: number | null;
  householdCount: string;
  householdGrossAnnualIncome: number | null;
  loginDetails?: string | null
  interestListName: string;
}
const Metadata: React.FC<Props> = ({
  position,
  householdCount,
  householdGrossAnnualIncome,
  loginDetails,
  interestListName,
}) => (<div className={styles.metadata}>
  <span>{position ? `#${position} in ` : ""}{interestListName}</span>
  <span> | </span>
  <span>Household Size: {householdCount}</span>

  {householdGrossAnnualIncome !== null && (
    <span> | Income: ${householdGrossAnnualIncome.toLocaleString()}</span>
  )}

  {loginDetails ? (
    <span> | Account: {loginDetails}</span>
  ) : (
    <span> | No Account</span>
  )}
</div>);

export default Metadata;
